import React from 'react'
import cls from 'classnames';
import HorizontalField, { HorizontalFieldProps } from '../horizontal_field';
import styles from "./Switch.module.scss";
import { Switch, SwitchProps } from './Switch';

interface Props extends SwitchProps, HorizontalFieldProps {
}

/**
 * A switch with a label.
 */
export const SwitchField: React.FC<Props> = (props) => {
  return (
    <HorizontalField
      containerClassName={cls([styles.field, props.containerClassName])}
      labelContainerClassName={styles.labelContainer}
      {...props}>
      <Switch {...props} />
    </HorizontalField>
  )
}